<template>
  <div class="auto-screen-view-container" ref="containerRef">
    <div :style="style" class="auto-screen-view-content">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, watch } from "vue";
import type { Props } from "./interface";
const props = withDefaults(defineProps<Props>(), {
  originHeight: 1080,
  originWidth: 1920,
  fullScreen: false,
});
const originRatio = computed(() => {
  return props.originWidth / props.originHeight;
});
const containerRef = ref<HTMLDivElement>();

const style = computed(() => {
  return {
    width: `${props.originWidth}px`,
    height: `${props.originHeight}px`,
  };
});

const retryResize = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const ratio = width / height;
  if (ratio > originRatio.value) {
    const scale = height / props.originHeight;
    containerRef.value?.style.setProperty(
      "--auto-screen-scale",
      scale.toString()
    );
  } else {
    const scale = width / props.originWidth;
    console.log(scale);
    containerRef.value?.style.setProperty(
      "--auto-screen-scale",
      scale.toString()
    );
  }
};

const changeFullScreen = () => {
  if (props.fullScreen) {
    document.documentElement.requestFullscreen();
  } else {
    document.exitFullscreen();
  }
};

onMounted(() => {
  retryResize();
  window.addEventListener("resize", retryResize);
});

watch(
  () => [props.originHeight, props.originWidth],
  () => {
    retryResize();
  }
);
watch(
  () => props.fullScreen,
  () => {
    changeFullScreen();
  }
);
</script>
